import '../../style/';
import '../../button/style/';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/result/style/index.web.tsx
 **/